<template>
  <div class="shell">
    <AppHeader />
    <main id="main" class="shell__main">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<style scoped>
.shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.shell__main {
  flex: 1;
}
</style>
